const REGIONS_OF_FLIGHT = {
  DOMESTIC: 'Domestic',
  TRANSBORDER: 'Transborder',
  SUDAMERICA_ASIA: 'AyS',
  EUROPA: 'Europe',
  CENTROAMERICA_CARIBE: 'CyC',
};

export default {
  REGIONS_OF_FLIGHT,
};
